import { useMutation } from '@tanstack/react-query';
import { service } from '@maia/customer';

export function useInsuranceOverview(
  customerGuid: string,
  onSuccess: (data: unknown) => void,
  onError: (data: unknown) => void,
) {
  return useMutation({
    mutationFn: () => service.getInsuranceOverview(customerGuid),
    onSuccess,
    onError,
  });
}
